var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('div',{staticClass:"component-layer"},[_c('div',{staticClass:"wrap",style:({width: _vm.width})},[_vm._t("default"),_c('div',{class:`close iconfont huaban ${_vm.close}`,on:{"click":_vm.closeFn}})],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }